import script from "./WorkspaceGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceGroups.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceGroups.vue?vue&type=style&index=0&id=7d5fc1d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5fc1d6"]])

export default __exports__